<ng-template #cellTemplateStage let-row="row" let-columnId="columnId">
  <div layout-horizontal layout-align-items-center padding-small>
    <rt-stage-category-color-indicator
      [stageCategory]="row.values[columnId].category ?? row.values[columnId].id"
      margin-right-small-x
    />
    <span class="stage-cell-value">{{ row.values[columnId].name }}</span>
  </div>
</ng-template>

<ng-template #nonClickableCell let-textContent="textContent" let-sign="sign">
  <div
    class="table-cell"
    [class.empty-duration]="data.dataset.metric.unitType === 'duration' && textContent === '0'"
    [class.sign-positive]="sign === 'positive'"
    [class.sign-negative]="sign === 'negative'"
  >
    <rt-truncate>
      {{ data.dataset.metric.unitType === 'duration' && textContent === '0' ? '-' : textContent }}
    </rt-truncate>
  </div>
</ng-template>

<ng-template #clickableCell let-row="row" let-cellIndex="cellIndex" let-textContent="textContent">
  <div class="table-cell clickable" (click)="openResourceAt.emit([row.index, cellIndex - 1])">
    <rt-icon name="open-in-new" />
    <rt-truncate>
      {{ textContent }}
    </rt-truncate>
  </div>
</ng-template>

<ng-template #headerCellStageCategory let-column="col">
  @if (column.index > 0) {
    <rt-stage-category-color-indicator [stageCategory]="column.id" margin-right-small-x />
  }
  <span [class.line-truncate]="column.index > 0">{{ column.label }}</span>
</ng-template>

<ng-template #headerCellDefault let-column="col">
  <span [class.line-truncate]="column.index > 0">{{ column.label }}</span>
</ng-template>

@let shadows = shadows$ | async;
@let pagination = (pagination$ | async) ?? undefined;
<div class="shadow-parent">
  <div
    [class.with-shadow]="!tableShadowHidden"
    #scrollContainer
    [class.shadow-left]="shadows?.left"
    [class.shadow-right]="shadows?.right"
    class="data-table-container overload"
  >
    <rt-data-table
      #dataTableComponent
      [columnHeaderTemplate]="headerCell"
      [cellPadding]="false"
      [rows]="dataTableRowsMapped | rtTablePagination: pagination"
      [cols]="dataTableColumnsMapped"
      [cellTemplates]="{
        'stage-category': cellTemplateStage,
        'stage-name': cellTemplateStage,
      }"
      [autoFit]="true"
      [clickable]="false"
      [defaultCellTemplate]="tableCellTemplate"
      (sortChange)="toggleColumnSort($event)"
    />
  </div>
</div>
<rt-toolbar #toolbarComponent class="pagination-toolbar">
  <rt-toolbar-secondary layout>
    @if (pagination && pagination.pagesCount > 1) {
      <rt-pagination-counter
        [total]="pagination.total"
        [start]="pagination.start"
        [end]="pagination.end"
        margin-right-small
      />
      <rt-pagination
        [page]="pagination.page"
        [pagesCount]="pagination.pagesCount"
        [prevPageDisabled]="pagination.page === 1"
        [nextPageDisabled]="pagination.page === pagination.pagesCount"
        (pageChange)="changePage($event)"
      />
    }
  </rt-toolbar-secondary>
</rt-toolbar>

<ng-template
  #tableCellTemplate
  let-row="row"
  let-columnId="columnId"
  let-rowIndex="rowIndex"
  let-cellIndex="cellIndex"
>
  <ng-container
    [ngTemplateOutlet]="isCellClickable(row.values[columnId]) ? clickableCell : nonClickableCell"
    [ngTemplateOutletContext]="{
      row: row,
      columnId: columnId,
      rowIndex: rowIndex,
      cellIndex: cellIndex,
      sign: row.values[columnId].sign,
      textContent: cellIndex === 0 ? row.values[columnId].name : row.values[columnId].formatted,
    }"
  />
</ng-template>
